var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3259 6.99026L0.287716 12.0248C0.197339 12.1128 0.125366 12.2179 0.075983 12.334C0.0265999 12.4501 0.00079155 12.5749 6.19888e-05 12.701C-0.000668049 12.8272 0.0236936 12.9522 0.0717301 13.0689C0.119766 13.1856 0.190519 13.2915 0.279872 13.3806C0.369225 13.4696 0.475393 13.54 0.592205 13.5877C0.709017 13.6353 0.834139 13.6593 0.960293 13.6582C1.08645 13.657 1.21112 13.6308 1.32705 13.5811C1.44298 13.5313 1.54786 13.459 1.63559 13.3683L7.34408 7.6642C7.5157 7.49127 7.61427 7.25899 7.61942 7.01541C7.62456 6.77183 7.53587 6.5356 7.3717 6.35558L1.63996 0.612201C1.4609 0.437804 1.22041 0.340856 0.970463 0.342302C0.720514 0.343748 0.481167 0.443473 0.304137 0.61993C0.127108 0.796387 0.0266085 1.03541 0.0243521 1.28535C0.0220957 1.53529 0.118264 1.77609 0.292079 1.95572L5.3259 6.99026Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeArrow);
export default __webpack_public_path__ + "static/media/orange-arrow.5a753abfd03ae6ecc35065d10c97db50.svg";
export { ForwardRef as ReactComponent };